/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticPrimitiveState,
  AnimaticPrimitiveState$inboundSchema,
  AnimaticPrimitiveState$Outbound,
  AnimaticPrimitiveState$outboundSchema,
} from "./animaticprimitivestate.js";

/**
 * The kind of animatic.
 */
export const AnimaticPrimitiveKind = {
  AlarmHornStrobe: "alarm-horn-strobe",
  Condenser: "condenser",
  ControlValve: "control-valve",
  Valve: "valve",
  ElectricUnderfloorHeater: "electric-underfloor-heater",
  Evaporator: "evaporator",
  ExhaustFan: "exhaust-fan",
  GasSensor: "gas-sensor",
  Generic: "generic",
  HeatExchanger: "heat-exchanger",
  Ltu: "ltu",
  MixingTank: "mixing-tank",
  Penthouse: "penthouse",
  Pump: "pump",
  RecipCompressor: "recip-compressor",
  RemoteSump: "remote-sump",
  ReverseOsmosis: "reverse-osmosis",
  ScrewCompressor: "screw-compressor",
  VentilationStack: "ventilation-stack",
  Vessel: "vessel",
  WaterBath: "water-bath",
} as const;
/**
 * The kind of animatic.
 */
export type AnimaticPrimitiveKind = OpenEnum<typeof AnimaticPrimitiveKind>;

/**
 * Defines a primitive animatic component. Primitives are the base of an animatic.
 */
export type AnimaticPrimitive = {
  /**
   * The kind of animatic.
   */
  kind: AnimaticPrimitiveKind;
  /**
   * The configuration of the animatic primitive for each allowed state.
   */
  states: Array<AnimaticPrimitiveState>;
};

/** @internal */
export const AnimaticPrimitiveKind$inboundSchema: z.ZodType<
  AnimaticPrimitiveKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticPrimitiveKind);
/** @internal */
export const AnimaticPrimitiveKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticPrimitiveKind
> = openEnums.outboundSchema(AnimaticPrimitiveKind);

/** @internal */
export const AnimaticPrimitive$inboundSchema: z.ZodType<
  AnimaticPrimitive,
  z.ZodTypeDef,
  unknown
> = z.object({
  kind: AnimaticPrimitiveKind$inboundSchema,
  states: z.array(AnimaticPrimitiveState$inboundSchema),
});
/** @internal */
export type AnimaticPrimitive$Outbound = {
  kind: string;
  states: Array<AnimaticPrimitiveState$Outbound>;
};

/** @internal */
export const AnimaticPrimitive$outboundSchema: z.ZodType<
  AnimaticPrimitive$Outbound,
  z.ZodTypeDef,
  AnimaticPrimitive
> = z.object({
  kind: AnimaticPrimitiveKind$outboundSchema,
  states: z.array(AnimaticPrimitiveState$outboundSchema),
});

export function animaticPrimitiveToJSON(
  animaticPrimitive: AnimaticPrimitive,
): string {
  return JSON.stringify(
    AnimaticPrimitive$outboundSchema.parse(animaticPrimitive),
  );
}
export function animaticPrimitiveFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticPrimitive, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticPrimitive$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticPrimitive' from JSON`,
  );
}
